import request from '@/utils/request.js'
import router from '@/router'

export default (vm) => {
  return {
    namespaced: true,
    state: {
      data: null
    },
    mutations: {
      data: (state, data) => {
        state.data = data
      }
    },
    actions: {
      handle: (context, playload) => {
        const url = playload.url
        const data = playload.data
        const method = playload.method ? playload.method : 'get'
        const callback = playload.callback
        const data1 = playload.data1 ? playload.data1 : false
        const callback1 = playload.callback1
        if (method === 'get' && data1 === true) {
          request.get(url, data).then(data => {
            if (callback) callback(data)
          }).catch(msg => {
            if (callback1)	callback1(msg)
            return
          })
        }
        if (method === 'get' && data1 === false) {
          request.get(url, data).then(data => {
            if (callback) callback(data)
          }).catch(msg => {
            context.rootGetters['alert'](msg)
          })
        } else if (method === 'put') {
          request.put(url, data).then(data => {
            if (callback) callback(data)
          }).catch(msg => {
            context.rootGetters['alert'](msg)
          })
        } else if (method === 'post') {
          request.post(url, data).then(data => {
            if (callback) callback(data)
          }).catch(msg => {
            context.rootGetters['alert'](msg)
          })
        } else if (method === 'delete') {
          request.delete(url, data).then(data => {
            if (callback) callback(data)
          }).catch(msg => {
            context.rootGetters['alert'](msg)
          })
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/form.js